
import GenericTableService from 'modules/base/service/GenericTableService';

class DeployService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'deployControl';
	}

	getState() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getState`, {})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new DeployService();